import {ReactElement} from 'react';

import {
  PossibleFeatureFlagsType,
  useFeatureFlagCheck,
} from '_/hooks/useFeatureFlagCheck';
import {usePermissionChecker} from '_/hooks/usePermissionChecker';

import {GlobalPermissionsType} from './types';

export const ConditionalRouteWrapper = ({
  featureName,
  requiredPermission,
  module,
}: {module: ReactElement} & (
  | {
      featureName: PossibleFeatureFlagsType;
      requiredPermission?: GlobalPermissionsType;
    }
  | {
      requiredPermission: GlobalPermissionsType;
      featureName?: PossibleFeatureFlagsType;
    }
)): ReactElement | null => {
  const {checkPermission} = usePermissionChecker();

  const isFlagActive = useFeatureFlagCheck(featureName);
  const hasPermission = checkPermission(requiredPermission);

  if ((featureName !== undefined && !isFlagActive) || !hasPermission) {
    return null;
  }

  return module;
};
